import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.css']
})
export class ContextMenuComponent implements OnInit {

  menu: any[];
  
  @Input() set contextMenuItems(val){
    console.log("VAL: ", val);
    
    this.menu = val;
  }


  constructor() { }

  ngOnInit(): void {
  }

}
